module.exports = __webpack_public_path__ + "img/background_c3-1_mask.998c023c.jpg";